import { getProductFilter } from '~/features/ProductList/utils';
import { Prefetch } from '~/services/types';
import { Loop54ProductAttributes } from '../types';
import {
    buildPreFetcherForPopularEntities,
    PopularEntitiesByPurchaseRequest,
    PopularEntitiesByPurchaseResponse,
    usePopularEntitiesByPurchase,
} from './usePopularEntitiesByPurchase';
import { AttributeFilterParameter } from '~/lib/data-contract/auto-generated/loop54-api-model';

const queryKey = 'popularEntities';

export default function usePopularEntities<SelectType = PopularEntitiesByPurchaseResponse>(
    params: PopularEntitiesByPurchaseRequest | undefined,
    select?: (data: PopularEntitiesByPurchaseResponse) => SelectType,
) {
    return usePopularEntitiesByPurchase(queryKey, params, select);
}

type PrefetchPopularEntities = Prefetch & {
    amount?: number;
    onlyCampaign?: boolean;
};

export function prefetchPopularEntities({ queryClient, amount }: PrefetchPopularEntities) {
    const filters: AttributeFilterParameter[] = [
        getProductFilter() as AttributeFilterParameter,
        {
            type: 'attribute',
            attributeName: Loop54ProductAttributes.InStock,
            value: true,
        },
    ];

    const params: PopularEntitiesByPurchaseRequest = {
        resultsOptions: {
            filter: {
                and: filters as AttributeFilterParameter[],
            },
            take: amount ?? 10,
        },
        behaviorType: 'purchase',
    };

    return buildPreFetcherForPopularEntities({ queryKey, params, queryClient });
}
